"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ArrowLeftAngleSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "arrow-left-angle", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M6,9.79289322 C6,10.0690356 5.77614237,10.2928932 5.5,10.2928932 C5.36739176,10.2928932 5.2402148,10.2402148 5.14644661,10.1464466 L1.70710678,6.70710678 C1.31658249,6.31658249 1.31658249,5.68341751 1.70710678,5.29289322 L5.14644661,1.85355339 C5.34170876,1.65829124 5.65829124,1.65829124 5.85355339,1.85355339 C5.94732158,1.94732158 6,2.07449854 6,2.20710678 L5.99921356,4.99910678 L11,5 C13.209139,5 15,6.790861 15,9 L15,12 C15,12.5522847 14.5522847,13 14,13 C13.4477153,13 13,12.5522847 13,12 L13,12 L13,9 C13,7.8954305 12.1045695,7 11,7 L5.99921356,6.99910678 L6,9.79289322 Z", id: "Combined-Shape", fill: "#000000" })));
}
function ArrowLeftAngle(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ArrowLeftAngleSvg, Object.assign({}, svgProps)));
}
exports.default = ArrowLeftAngle;
//# sourceMappingURL=ArrowLeftAngle.js.map